export class API {
  public static readonly API_URL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API : 'https://signup.net2phone.com/api/';
}
